import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getPincodeLocations(cookies, pincode) {
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/consignees/pincode_locations/`, {
            params: { pincode },
        })
        .then((r) => r.data);
}

export async function getPincodeStreets(cookies, pincode, locality) {
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/consignees/pincode_streets/`, {
            params: { pincode, locality },
        })
        .then((r) => r.data);
}

export async function getPincodeLookup(cookies, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
        }
    });
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/consignees/pincode_lookup/?${query.toString()}`)
        .then((r) => r.data);
}

export async function getLocationDistance(cookies, params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.set(key, String(value));
        }
    });
    return getApiClient(cookies)
        .get(`${apiBaseUrl}/consignees/location_distance/?${query.toString()}`)
        .then((r) => r.data);
}
